import { configureStore } from "@reduxjs/toolkit";
import { sharesApi } from "@services/share";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { rootReducer } from "utils";

// Create the store instance
export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([sharesApi.middleware]),
});

export type RootState = ReturnType<typeof rootReducer>;
// Infer AppStore and AppDispatch types from the store
export type AppStore = typeof store;
export type AppDispatch = AppStore["dispatch"];

// Setup listeners for rtk-query hooks
setupListeners(store.dispatch);

// Export store as default
export default store;
